import { SlackForm } from '@modules/integrations/components/SlackIntegration/SlackForm';
import { EditIntegrationIncompleteWarningAlert } from '@modules/integrationsV2/components/EditIntegrationDrawerContent/EditIntegrationIncompleteWarningAlert';
import { useUpdateIntegration } from '@modules/integrationsV2/hooks';
import { EditIntegrationDrawerContentProps } from '@modules/integrationsV2/types';
import { trackEditIntegrationEvent } from '@modules/integrationsV2/utils';
import { Box } from '@mui/material';
import { IntegrationChannelType, SlackChannelInput } from 'generated/graphql';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { AddOrEditIntegrationDrawerHeader } from '../../AddOrEditIntegrationDrawerHeader';

export const EditSlackIntegrationDrawerContent = ({
  onDrawerClose,
  integrationID,
  integrationData,
  integrationType,
  integrationChannel,
}: EditIntegrationDrawerContentProps) => {
  const [updateIntegration, { status: updateIntegrationStatus }] =
    useUpdateIntegration({
      channelType: IntegrationChannelType.Slack,
      integrationType,
      onCompleted: () => {
        onDrawerClose();
        trackEditIntegrationEvent({
          eventName: 'Edit Integration Submitted',
          channelType: IntegrationChannelType.Slack,
          integrationID,
        });
      },
    });

  const updateSlackChannels = (
    selectedChannels: SlackChannelInput[],
    additionalOrgDomains: string[],
  ) => {
    updateIntegration({
      integrationID,
      isActive: true,
      updateData: {
        slack: {
          subscribedChannels: selectedChannels,
          additionalOrgDomains,
        },
      },
    });
  };

  return (
    <>
      <AddOrEditIntegrationDrawerHeader
        integrationChannel={integrationChannel}
        integrationType={integrationType}
        title="Edit Slack Integration"
      />
      <Box py={3} px={4}>
        <EditIntegrationIncompleteWarningAlert
          integrationData={integrationData}
          channelType={IntegrationChannelType.Slack}
        />
        <SlackForm
          integrationID={integrationID}
          onSubmit={updateSlackChannels}
          integrationData={integrationData}
          isLoading={IsLoading(updateIntegrationStatus)}
        />
      </Box>
    </>
  );
};
